import type { ICountryObject } from "app/services/CountryService";
import DurationService, { BasicDurations } from "app/services/DurationService";
import { DEVICES_TYPES_FOR_API } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import type { IWebsiteType } from "pro-features/components/filtersPanel/src/WebsiteTypeFilter";
import { MAX_DOMAINS_IN_CATEGORY } from "app/components/customCategoriesWizard/custom-categories-max-domains";

export const ROWS_PER_PAGE = 100;
export const getCommonQueryParams = (countryObject: ICountryObject, websiteType: IWebsiteType) => {
    const duration = BasicDurations.LAST_MONTH;
    const webSource = DEVICES_TYPES_FOR_API.TOTAL;
    const { from, to, isWindow } = DurationService.getDurationData(duration).forAPI;
    const { id: country } = countryObject;
    const pageSize = MAX_DOMAINS_IN_CATEGORY + ROWS_PER_PAGE;
    const { id: websiteTypeID } = websiteType;
    const funcFlag = websiteTypeID.length > 0 ? parseInt(websiteTypeID) : undefined;
    return {
        from,
        to,
        isWindow,
        webSource,
        pageSize,
        country,
        funcFlag,
        page: 1,
    };
};
